import type { RouteRecordRaw } from 'vue-router';
import { validateMcpAuthorization } from './mcp.guard';

const PublicLayout = () => import('@/shared/layouts/pages/PublicLayout/index.vue');

const McpConsentPage = () => import('@/modules/mcp/pages/McpConsent/index.vue');

export const mcpPublicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/oauth',
    component: PublicLayout,
    children: [
      {
        path: 'authorize',
        name: 'mcp-oauth-authorize',
        component: McpConsentPage,
        beforeEnter: validateMcpAuthorization,
      },
    ],
  },
];
